<div class="sidenav-content" cdkScrollable *ngIf="!submitting && !isLoading; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register' | translate) +' - '+ ('guarantee.magnelissolar.long' | translate)">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary" (click)="goToNextStep($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<form>
		<div class="copo-form-container copo-grid">
			<copo-stepper class="copo-stepper-container" [steps]="steps"></copo-stepper>
			<copo-feedback-error></copo-feedback-error>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.customer.information</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column" #nameDiv>
					<mat-form-field>
						<mat-label translate>guarantee.project.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="35"
							[formControl]="projectNameFormControl" (change)="projectNameChanged($event)" required>
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
						<mat-error *ngIf="projectNameFormControl.hasError('required')"><span
							translate>guarantee.project.name.mandatory</span></mat-error>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-column" #soldToDiv>
					<mat-form-field>
						<mat-label translate>guarantee.customer.name</mat-label>
						<mat-select (selectionChange)="soldToChanged($event)" [formControl]="soldToFormControl"
							required>
							<mat-option *ngFor="let corporate of soldTos" [value]="corporate.businessId">
								{{corporate.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="soldToFormControl.hasError('required')"><span
								translate>guarantee.corporate.name.mandatory</span></mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.characteristics</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<span class="copo-label" translate>guarantee.type.of.installation</span>
				</div>
			</div>
			<div class="copo-grid-row">
				<mat-radio-group class="copo-inline-radio-group" [formControl]="installationTypeFormControl"
					(change)="onInstallationTypeChange($event)">
					<div class="copo-grid-row-column">
						<mat-radio-button value="Ground mounted / utility scale solar plant">
							<span translate>guarantee.ground.mounted</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button value="Rooftop installation">
							<span translate>guarantee.rooftop.installation</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button value="Floating Solar Installation">
							<span translate>guarantee.floating.solar.installation</span>
						</mat-radio-button>
					</div>
				</mat-radio-group>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<span class="copo-label" translate>guarantee.planned.operations</span>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" 
						(change)="onNewSolarPlantCheckboxChange($event.checked)"
						[formControl]="newSolarPlantFormControl">
						<span translate>guarantee.new.solar.plant</span>
					</mat-checkbox>
				</div>
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" 
						(change)="onExistingSolarPlantCheckboxChange($event.checked)"
						[formControl]="existingSolarPlantFormControl">
						<span translate>guarantee.extension.solar.plant</span>
					</mat-checkbox>
				</div>
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" 
						(change)="onRetrofittingSolarPlantCheckboxChange($event.checked)"
						[formControl]="retrofittingSolarPlantFormControl">
						<span translate>guarantee.retrofitting.solar.plant</span>
					</mat-checkbox>
				</div>
			</div>
			<br>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.size</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<mat-form-field class="copo-grid-row-column">
					<mat-label translate>guarantee.power.generation</mat-label>
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
						[formControl]="powerFormControl" (change)="powerNameChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
				</mat-form-field>
				<mat-form-field class="copo-grid-row-column">
						<mat-label translate>guarantee.tonnage.magnelis</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
							[formControl]="magnelisTonnageFormControl" (change)="magnelisTonnageNameChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
				</mat-form-field>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.mounting.system.producer</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-form-field>
						<mat-label translate>guarantee.msp.company.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
							[formControl]="mspCompanyNameFormControl" (change)="mspCompanyNameChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-columns">
					<h2 translate>guarantee.epc</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-form-field>
						<mat-label  translate>guarantee.epc.company.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
							[formControl]="epcCompanyNameFormControl" (change)="epcCompanyNameChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
					</mat-form-field>
				</div>
			</div>
		</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>